<template>
    <Section class="home">
        <Loading v-if="isLoading"/>
        <ProfileHeader/>
        <div class="home-container form-green">
            <el-input :placeholder="$t('commons.search')" v-model="search" clearable/>
            <DocumentListBase :filters="searchFilters" ref="list">
                <template slot="list-item" slot-scope="scope">
                    <DocumentListItem :item="scope.item" :key="scope.index" class=""></DocumentListItem>
                </template>
            </DocumentListBase>
        </div>
    </Section>
</template>

<i18n>
{
    "en": {
        "home": {
            "header": {
                "title": "Your certified documents",
                "subTitle": "This is a list of your certified documents. They have all been sent by verified organizations and are certified by Smart Certificate. Click on any on them to see all the sharing possibilities."
            }
        }
    },
    "es": {
        "home": {
            "header": {
                "title": "Sus documentos certificados",
                "subTitle": "Esta es una lista de sus documentos certificados. Todos ellos han sido enviados por organizaciones verificadas y están certificados por Smart Certificate. Haga clic en cualquiera de ellos para ver todas las posibilidades de compartirlos."
            }
        }
    },
    "fr": {
        "home": {
            "header": {
                "title": "Vos documents certifiés",
                "subTitle": "Voici la liste de vos documents certifiés. Ils ont tous été envoyés par des organisations vérifiées et sont certifiés par Smart Certificate. Cliquez sur l'un d'eux pour voir toutes les possibilités de partage."
            }
        }
    },
    "pt": {
        "home": {
            "header": {
                "title": "Os seus documentos certificados",
                "subTitle": "Esta é uma lista dos seus documentos certificados. Todos eles foram enviados por organizações verificadas e são certificados pelo Smart Certificate. Clique em qualquer um deles para ver todas as possibilidades de partilha."
            }
        }
    },
    "de": {
        "home": {
            "header": {
                "title": "Ihre beglaubigten Dokumente",
                "subTitle": "Dies ist eine Liste Ihrer zertifizierten Dokumente. Sie wurden alle von verifizierten Organisationen gesendet und sind von Smart Certificate zertifiziert. Klicken Sie auf ein beliebiges Dokument, um alle Freigabemöglichkeiten zu sehen."
            }
        }
    },
    "nl": {
        "home": {
            "header": {
                "title": "Je gecertificeerde documenten",
                "subTitle": "Dit is een lijst van je gecertificeerde documenten. Ze zijn allemaal verstuurd door geverifieerde organisaties en gecertificeerd door Smart Certificate. Klik op een document om alle mogelijkheden voor delen te zien."
            }
        }
    }
}
</i18n>

<script>
import Section from '@/components/v3/section/Section.vue'
import SectionHeader from '@/components/v3/section/SectionHeader.vue'
import ProfileHeader from './ProfileHeader.vue'
import DocumentListItem from '@/modules/documents/components/DocumentListItem'
import DocumentListBase from '@/modules/documents/components/DocumentListBase.vue'
import { documentServices } from '@/modules/documents/services/DocumentServices'
import Loading from '@/components/v3/loading/Loading.vue'
import ProfileHeaderVue from './ProfileHeader.vue'

export default {
    components: {
        Section,
        SectionHeader,
        ProfileHeader,
        DocumentListItem,
        DocumentListBase,
        Loading
    },
    props: {
    },
    data() {
        return {
            isLoading: false,
            originalItems: [],
            search: ''
        }
    },
    computed: {
        searchFilters () {
            let a = [
                (item) => {
                    if (item.documentId.toString().toLowerCase().indexOf(this.search) >= 0) return true
                    if (item.documentName.toString().toLowerCase().indexOf(this.search) >= 0) return true
                    if (item.organizationName.toString().toLowerCase().indexOf(this.search) >= 0) return true
                    if (item.groupName.toString().toLowerCase().indexOf(this.search) >= 0) return true
                    return false
                }
            ]
            return a
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

$inside-width = 1260px
$outside-padding = 84px
$outside-width = $inside-width + ($outside-padding * 2)
$el-vertical-space = 10px

$content-max-width = 1000px
$responsive-mul = 0.1
$responsive-max-width = $outside-width
$responsive-min-width = $responsive-max-width * $responsive-mul

.home

    .section-content
        responsive-styling(padding-top, 114px, 114px, $responsive-max-width * responsive-width-min-scale, $responsive-max-width)
        // responsive-styling-auto-scale(padding-top, $outside-padding, $responsive-max-width)
        responsive-styling-auto-scale(padding-left, $outside-padding, $responsive-max-width)
        responsive-styling-auto-scale(padding-right, $outside-padding, $responsive-max-width)
        responsive-styling-auto-scale(padding-bottom, $outside-padding, $responsive-max-width)
        responsive-styling-auto-scale(gap, 10, $responsive-max-width)

    .home-header
        display flex
        width 100%

        .home-header-left
            flex 0 1 auto
            width 460px

            .learn-more
                display block
                font-size 20px
                color $color-primary
                font-weight bold
                margin-top 24px

                .icon
                    font-size 12px
                    font-weight normal
                    margin-left 12px

        .home-header-right
            flex 1 1 auto
            mix-blend-mode multiply
            position relative

            img
                position absolute
                top -100px
                width 474px

    .home-container
        display flex
        flex-direction column
        responsive-styling-auto-scale(margin-top, 96px, $responsive-max-width)
        width 100%

        .el-input
            margin-bottom 24px

</style>



// WEBPACK FOOTER //
// src/modules/home/components/Home.vue